// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-border[data-v-eecaaf4a]{margin:2px auto;border-top:2px solid #e6e6e6}.border-hover-success[data-v-eecaaf4a]{border:2px solid transparent}.border-hover-success[data-v-eecaaf4a]:hover{border:2px solid #28a745}", ""]);
// Exports
module.exports = exports;
